import React ,{ useEffect, useState }from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
} from 'quanta-ui';

export default function PolicyClaimDetails({ fireQuote, role }) {
  const isQuoteReadOnly =
    [
    'quote saved',
    'underwriter approved',
    'underwriter rejected',
    'converted to proposal',
    ]?.includes(fireQuote?.status?.toString()?.toLowerCase()) ||
    (role?.toString()?.toLowerCase() !== 'underwriter' &&
      fireQuote?.status?.toString()?.toLowerCase() ===
        'pending uw approval');

  const { values } = useQuantaFormikContext();

  const [alerts, setAlerts] = useState([]);

  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });

  let grid_data = [
    {
      type: 'radiogroup',
      label: (
        <>
          Does the Property have claim in last 3 Yrs?
          <Text severity="error"> *</Text>
        </>
      ),
      colSpan: inputColSpans,
      className: '-mb-4',
      name: 'previousClaimExperienceDetails.isClaimMadeInPreviousYears',
      disabledGlobal: isQuoteReadOnly,
      data: [
        {
          label: 'Yes',
          value: 'Yes',
        },
        {
          label: 'No',
          value: 'No',
        },
      ],
    },
    // values?.previousClaimExperienceDetails?.isClaimMadeInPreviousYears
    //   ?.toString()
    //   ?.toLowerCase() === 'yes'
    //   ? {
    //       type: 'textarea',
    //       size: 'large',
    //       rows: 2,
    //       colSpan: inputColSpans,
    //       disabled: fireQuote?.status?.toString()?.toLowerCase() === 'quote saved',
    //       label: (
    //         <>
    //           Tell us about the claims in previous years
    //           <Text severity="error"> *</Text>
    //         </>
    //       ),
    //       name: 'previousClaimExperienceDetails.claimInPreviousYearsInfo',
    //     }
    //   : null,
  ].filter((d) => d);

  return (
    <div>
      <InputGrid
        data={grid_data}
        repeat={inputColSpans}
        titleType="title"
        titleSeverity="info"
        size="large"
        gapX={10}
      />
    </div>
  );
}
